import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import "@perxis-auto/shared";
import { FormatterDataTypeEnum } from "../../../shared/types/formatter.js";
import "react";
import { name } from "../config/name.js";
import "../model/middleware/index.js";
import "../model/selectors/selectAllFilterValues.js";
import { selectAllFilterValuesParameters } from "../model/selectors/selectAllFilterValuesParameters.js";
import "../model/selectors/selectAvailableFilterValues.js";
import "../model/selectors/selectAvailableFilterValuesParameters.js";
import "../model/selectors/selectAvailableFilterValuesQueries.js";
import "../model/selectors/selectDependentFilterKeysByKey.js";
import "../model/selectors/selectFilterImmutableQueries.js";
import "../model/selectors/selectFilterImmutableValues.js";
import "../model/selectors/selectFilterItemByKey.js";
import "../model/selectors/selectFilterItems.js";
import "../model/selectors/selectFilterValuesFields.js";
import "../model/selectors/selectGroupedFilterItemByKey.js";
import "../model/selectors/selectIsFilterValuesMissing.js";
import { createAppApi } from "../../../shared/lib/store/createAppApi.js";
import "../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../shared/lib/store/createAppSelector.js";
import "../../../shared/lib/store/createAppSlice.js";
import "redux";
import "../../../shared/lib/store/hooks/useAppDispatch.js";
import "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
import "../../../shared/config/env.js";
import "../../../shared/config/events.js";
import "react-router";
import "../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../shared/store/config/model/selectors/selectFilterGrid.js";
import { selectFilterGridItems } from "../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../shared/store/config/model/selectors/selectModels.js";
import "../../../shared/store/config/model/selectors/selectSort.js";
import "../../../shared/store/config/model/selectors/selectTags.js";
import "../../../shared/store/config/model/selectors/selectTradeIn.js";
import "../../../shared/store/config/model/slice.js";
import "../../../shared/store/installation/model/slice.js";
import "../../../shared/store/pagination/model/slice.js";
import "../../filterChoice/model/middleware/index.js";
import "../../filterChoice/model/selectors/selectFilterHistory.js";
import "../../filterChoice/model/selectors/selectFilterSortValue.js";
import { selectFilterValues } from "../../filterChoice/model/selectors/selectFilterValues.js";
import "../../filterChoice/model/selectors/selectFilterValuesCount.js";
import "../../filterChoice/model/selectors/selectIsFilterValuesSelected.js";
import "../../filterChoice/model/selectors/selectIsInitialSortValuesSelected.js";
import "../../filterChoice/model/selectors/selectIsValidSortValuesSelected.js";
import "../../filterChoice/model/selectors/selectSlugedFilterValues.js";
import "../../filterChoice/model/slice.js";
import "../../../shared/store/config/middleware/index.js";
import { dataFormatter } from "../../../shared/store/config/lib/dataFormatter.js";
import { createFilterValuesItem } from "../lib/api/create/createFilterValuesItem.js";
import { fetchAllFilterValues } from "../lib/api/fetchAllFilterValues.js";
import { fetchAvailableFilterValues } from "../lib/api/fetchAvailableFilterValues.js";
const api = createAppApi({
  reducerPath: name,
  baseQuery: fetchBaseQuery(),
  endpoints: (builder) => ({
    getAllFilterValues: builder.query({
      queryFn: async (parameters, queryApi) => {
        const allFilterValuesItem = await fetchAllFilterValues(queryApi, parameters);
        return {
          data: allFilterValuesItem
        };
      }
    }),
    // Получение фильтров с возможными значениями фильтрации
    getAvailableFilterValues: builder.query(
      {
        queryFn: async (parameters, queryApi) => {
          const state = queryApi.getState();
          const allFilterValuesParameters = selectAllFilterValuesParameters(state);
          const { data: allRawFilterValuesItem } = api.endpoints.getAllFilterValues.select(allFilterValuesParameters)(state);
          if (!allRawFilterValuesItem) {
            throw new Error("Отсутствуют данные по фильтрам");
          }
          const filterValuesChoice = selectFilterValues(state);
          const filterGridItems = selectFilterGridItems(state);
          const availableRawFilterValuesItem = await fetchAvailableFilterValues(
            queryApi,
            parameters,
            allRawFilterValuesItem
          );
          const availableFilterValuesItem = createFilterValuesItem(
            allRawFilterValuesItem,
            availableRawFilterValuesItem,
            filterValuesChoice,
            filterGridItems
          );
          const formattedAvailableFilterValuesItem = dataFormatter(
            queryApi,
            FormatterDataTypeEnum.FilterValues,
            availableFilterValuesItem
          );
          return {
            data: formattedAvailableFilterValuesItem
          };
        }
      }
    )
  })
});
const { reducer, reducerPath } = api;
export {
  api,
  reducer,
  reducerPath
};
